import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

import { addressFormFields } from './addressFieldsForm';

const formFields = [
  ...addressFormFields,
  {
    name: 'owners',
    label: 'Choose Borrower',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'propertyType',
    label: 'Property Type',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'propertyValue',
    label: 'Current Market Value',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'status',
    label: 'Property Status',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'occupancy',
    label: 'Intended Occupancy',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'taxesEscrowed',
    label: 'Taxes are Escrowed',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'homeownersInsuranceEscrowed',
    label: 'Homeowners Insurance is Escrowed',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'monthlyPropertyTaxes',
    label: 'Monthly Property Taxes',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'monthlyHomeownersInsurance',
    label: 'Monthly Homeowners Insurance',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'monthlyPmi',
    label: 'Monthly PMI',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'associationFees',
    label: 'Association Fee',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'associationFeesAmount',
    label: 'Monthly Fee',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'associationFeesName',
    label: 'Association Name',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'associationFeesEmail',
    label: 'Association Email',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'associationFeesPhoneNumber',
    label: 'Association Phone Number',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'hasOtherExpenses',
    label: 'Other Expenses',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'otherExpensesName',
    label: 'Other Expenses Name',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'otherExpensesValue',
    label: 'Other Expenses Amount',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'hasMortgage',
    label: 'Mortgage on the property',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'liabilityId',
    label: 'Mortgage Liability',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'unpaidBalance',
    label: 'Amount Owed',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'monthlyPayment',
    label: 'Amount Of Payment',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'highLimit',
    label: 'High Limit',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'liabilityLinkedToPropertyGroup',
    label: 'Liability Linked To Property Group',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'toBePaidOffAtOrBeforeClosing',
    label: 'Payoff required',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'isSubordinate',
    label: 'Subordinate',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'excludePayment',
    label: 'Exclude Payment',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'rentCalculatedBasedOn',
    label: 'Rent calculated based on',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'monthlyRentalIncome',
    label: 'Gross Rent',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'mortgagesPayment',
    label: 'Mortgages Payment(s)',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'expenses',
    label: 'Expenses',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'netMonthlyRentalIncome',
    label: 'Net Rent',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const reoForm = {
  name: FormNames.REO,
  label: 'REO',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
